import { render } from "../views/container-tag.html?vue&type=template&id=5461d448&ts=true&external"
import script from "../scripts/container-tag.ts?vue&type=script&lang=ts&external"
export * from "../scripts/container-tag.ts?vue&type=script&lang=ts&external"

import "../css_builds/components/container-tag.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"ClientApp/components/container-tag.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5461d448"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5461d448', __exports__)) {
    api.reload('5461d448', __exports__)
  }
  
  module.hot.accept("../views/container-tag.html?vue&type=template&id=5461d448&ts=true&external", () => {
    api.rerender('5461d448', render)
  })

}


export default __exports__